import { doorClient, ImResponse, leyanbotClient, resolve } from 'services/api';

export interface getSpuClassParams {
  keyWord?: string;
  spuClassName?: string;
  keyWordType?: string;
}
export const getSpuClass = (params?: getSpuClassParams) => {
  return resolve<Knowledge.SingleClass.Value[]>(
    doorClient.get('/knowledge/spu_knowledges/spu_class', {
      params,
    }),
  );
};

export const getClassKnowledges = (spuClassId: string) => {
  return resolve<Knowledge.SingleClass.Knowledge[]>(
    doorClient.get('/knowledge/spu_knowledges/spu_class/knowledges/v2', {
      params: {
        spuClassId,
      },
    }),
  );
};

export const getClassSpus = (spuClassId: string) => {
  return resolve<Knowledge.SingleClass.Value['spus']>(
    doorClient.get('/knowledge/spu_knowledges/spu_class/spus', {
      params: {
        spuClassId,
      },
    }),
  );
};

export const getClassSpuKnowledgeDetail = (spuClassId: string, knowledgeId: string) => {
  return resolve<Knowledge.SingleClass.Detail>(
    doorClient.get('/knowledge/spu_knowledges/spu_class/knowledge_detail', {
      params: {
        spuClassId,
        knowledgeId,
      },
    }),
  );
};

export const getUnboundedNum = () => {
  return resolve<{
    total: number;
    unboundNum: number;
  }>(leyanbotClient.get('/oversea-knowledge/spu_knowledges/v3/spu_class/unbound_num'));
};

export const getSpuClassList = (spuId: string | number) => {
  return resolve(
    leyanbotClient.get<
      ImResponse<{
        spuClassInfoList: {
          id: number;
        }[];
      }>
    >('/oversea-knowledge/spu_knowledges/v3/batch_spuClass_by_spuId', { params: { spuId } }),
  );
};
